export const PreviewAspects = Object.freeze({
	ASPECT_16_BY_9: 56.25,
	ASPECT_16_BY_10: 62.5,
	ASPECT_4_BY_3: 75,
	ASPECT_195_BY_9: 41.15,
	ASPECT_9_BY_16: 177.77,
	ASPECT_19_5_BY_9: 41.15,
	ASPECT_38_BY_21: 52.63,
});

export const PreviewAspectNames = Object.freeze({
	ASPECT_16_BY_9: '16:9',
	ASPECT_16_BY_10: '16:10',
	ASPECT_4_BY_3: '4:3',
	ASPECT_195_BY_9: '19.5:9',
	ASPECT_9_BY_16: '9:16',
});

export const AspetMultipliers = Object.freeze({
	56.25: 16 / 9,
	62.5: 16 / 10,
	75: 4 / 3,
	41.15: 19.5 / 9,
	177.77: 9 / 16,
	52.63: 38 / 21,
});
